import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { authFetch } from '../../Utilities/Api';
import './CreateAvatarItem.css';

const CreateAvatarItem = () => {
    const [formData, setFormData] = useState({
        name: '',
        type: '',
        imageUrl: '',
        tokenCost: '',
        echoCost: '',
        rarity: 'common',
        available: true,
        styleTags: ''
    });
    const [uploading, setUploading] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const form = new FormData();
        form.append('image', file);

        setUploading(true);
        try {
            const res = await authFetch('/api/upload/avatar', {
                method: 'POST',
                body: form
            });
            const data = await res.json();
            setFormData(prev => ({ ...prev, imageUrl: data.url }));
        } catch (err) {
            toast.error('❌ Failed to upload image');
        } finally {
            setUploading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...formData,
            tags: formData.styleTags.split(',').map(tag => tag.trim()),
            tokenCost: Number(formData.tokenCost) || 0,
            echoCost: Number(formData.echoCost) || 0,
        };

        try {
            await authFetch.post('/api/admin/avatar-items', payload);
            toast.success('✅ Avatar item created!');
            setFormData({
                name: '',
                type: '',
                imageUrl: '',
                tokenCost: '',
                echoCost: '',
                rarity: 'common',
                available: true,
                styleTags: ''
            });
        } catch (err) {
            console.error('❌ Failed to create item:', err);
            toast.error('Something went wrong');
        }
    };

    return (
        <div className="admin-avatar-form page-wrapper">
            <h2>Create Avatar Item</h2>
            <form onSubmit={handleSubmit} className="avatar-form">
                <label>
                    Name:
                    <input name="name" value={formData.name} onChange={handleChange} required />
                </label>

                <label>
                    Type:
                    <select name="type" value={formData.type} onChange={handleChange} required>
                        <option value="">Select Type</option>
                        <option value="hat">Hat</option>
                        <option value="shirt">Shirt</option>
                        <option value="pants">Pants</option>
                        <option value="shoes">Shoes</option>
                        <option value="accessory">Accessory</option>
                        <option value="hair">Hair</option>
                        <option value="eyes">Eyes</option>
                        <option value="mouth">Mouth</option>
                        <option value="background">Background</option>
                    </select>
                </label>

                <label>
                    Upload Image:
                    <input type="file" accept="image/*" onChange={handleFileUpload} />
                </label>

                <label>
                    Token Cost:
                    <input name="tokenCost" type="number" value={formData.tokenCost} onChange={handleChange} />
                </label>

                <label>
                    Echo Cost:
                    <input name="echoCost" type="number" value={formData.echoCost} onChange={handleChange} />
                </label>

                <label>
                    Rarity:
                    <select name="rarity" value={formData.rarity} onChange={handleChange}>
                        <option value="starter">Starter</option>
                        <option value="common">Common</option>
                        <option value="uncommon">Uncommon</option>
                        <option value="rare">Rare</option>
                        <option value="limited">Limited</option>
                        <option value="epic">Epic</option>
                        <option value="legendary">Legendary</option>
                        <option value="mythical">Mythical</option>
                        <option value="one-offs">One-Offs</option>
                        <option value="community designed">Community Designed</option>
                    </select>
                </label>

                <label>
                    Style Tags (comma separated):
                    <input name="styleTags" value={formData.styleTags} onChange={handleChange} />
                </label>

                <label className="checkbox-label">
                    <input type="checkbox" name="available" checked={formData.available} onChange={handleChange} />
                    Available
                </label>

                <button type="submit" disabled={uploading}>
                    {uploading ? 'Uploading...' : 'Create Avatar Item'}
                </button>
            </form>

            {formData.imageUrl && (
                <div className="avatar-preview">
                    <p>Preview:</p>
                    <img src={formData.imageUrl} alt="preview" />
                </div>
            )}
        </div>
    );
};

export default CreateAvatarItem;
